// 判断火车票订单状态颜色样式
const getTrainStateColor = item => {
  let {
    status
  } = item;

  if ([2].indexOf(status) !== -1) {
    return 'orange';
  } else if ([3, 4, 5, 7, 8, 9].indexOf(status) !== -1) {
    return 'blue';
  } else {
    return 'gray';
  }
};

const getTrainStatusValue = item => {
  let {
    status
  } = item;
  const value = {
    "1": '已完成',
    "2": '待支付',
    "3": '已支付',
    "4": '出票成功',
    "5": '退票中',
    "6": '订单关闭',
    "7": '改签待确认',
    "8": '改签中',
    "9": '已改签',
    "11": "出票失败",
    "13": "改签出票失败",
    "14": "已退票",
    "15": "已退票",
    "16": "待支付",
    "17": "抢票中",
    "18": "抢票失败",
    "21": "占座中",
    "22": "出票中",
    "23": "改签占座中",
    "24": "改签出票中"
  };
  return value[status] ? value[status] : '';
};

module.exports = {
  getTrainStateColor,
  getTrainStatusValue
};